import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/** Merge Tailwind classes so a caller's class always beats the component's
 *  default rather than depending on stylesheet order. */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
